export const BIGGEST_INTERVAL_NUMBER = 2 ** 31 - 1
